import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Box, Typography } from '@mui/material';
import IconButton from '@mui/joy/IconButton';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { ContextFromSelections } from './Context';
import { useContext,useState, useEffect } from 'react';
import { useNotify } from './Utils';





const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default function InputFileUpload() {

  
    const [selectedData, setSelectedData] = useContext(ContextFromSelections);
    const [fileName,setfileName] = useState(selectedData.uploaded_file_name || 'No file chosen')
    const [file,setfile] = useState(selectedData.uploaded_file || null)
    const notify = useNotify()
    const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp','image/svg+xml'];
    
    const  FileHandler = (event) => {
        if (event.target.files[0]) {
            if (!validTypes.includes(event.target.files[0].type)) {
                notify({message: "Please upload an image in JPG, PNG, WEBP, SVG or GIF format.",variant: "warning",duration: 3500})
                return;
            }
            const uploaded_file = event.target.files[0]
            setfile(uploaded_file);
            setfileName(uploaded_file.name);   

        }
       
    };

    

    const FileCancelHandler = () => {

            setfileName('No file chosen');
            setfile(null);
            setSelectedData({...selectedData,uploaded_file: file, uploaded_file_name: fileName})
        }

    useEffect(() => {
        if (!file?.name) {
           FileCancelHandler();
        }
        else {
            setSelectedData((data) => ({...data,
                uploaded_file: file,
                uploaded_file_name: fileName
            }))
        }
        },[file,fileName])

    return (
        
                <Box
                    sx={{
                        margin: "auto",
                        }}>
                
               <Box  
                    sx={{
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                        // border: "2px solid blue"
                        }}>
                            
                <Button
                        
                        component="label"
                        role={undefined}
                        variant="outlined"
                        tabIndex={-1}
                        startIcon={<CloudUploadIcon />}
                        sx={{width: 250,height: 30,fontSize: 13,display: "flex", justifyContent: "center"}}
                      
                        
                    >
                    Upload your Logo

                    <VisuallyHiddenInput
                        type="file"
                        accept="image/*"
                        onChange={FileHandler}
                        // multiple
                    />
                    
                    </Button>
                    </Box>
                    
                    <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: 30,
                        // border: "2px solid blue",
                        gap:1,
                        }}>
                    
                    <Typography
                    sx={{
                      
                        fontStyle: 'oblique',
                        fontSize: 12,
                        
                        }} 
                        >
                    
                        {fileName}
                    </Typography>
                        {file && 
                        <IconButton
                            size="small"
                            variant="outlined"
                            color="neutral"
                            onClick={FileCancelHandler}
                        >
                            <CloseRounded/>
                        </IconButton>
                        }
                        
                        </Box>
                               
                    </Box>
    );
}

